import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalComponent } from 'ngx-boot-modal';
import { getLastMillisOfDate } from '../../../../core/utils/date.utils';

@Component({
  selector: 'app-datepicker-modal',
  templateUrl: './datepicker-modal.component.html',
  styleUrls: ['./datepicker-modal.component.css']
})
export class DatepickerModalComponent implements OnInit {
  form: FormGroup;
  minDate: number;
  maxDate: number;
  @Input() title: string;
  @Input() message: string;
  @Input() confirmLabel = 'action.confirm';
  @Input() cancelLabel = 'action.cancel';
  @Output() save = new EventEmitter<number>();
  @ViewChild(ModalComponent) modal: ModalComponent;

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      pickedDate: ['', Validators.required ]
    });
  }

  open(value: Date, min: number = null, max: number = null) {
    this.minDate = min;
    this.maxDate = max;
    this.updateForm(value);
    this.modal.open();
  }

  onConfirm() {
    this.modal.close();
    this.save.emit(getLastMillisOfDate(this.form.value.pickedDate));
  }

  onCancel() {
    this.modal.close();
  }

  private updateForm(value: Date) {
    this.form.reset({ pickedDate: value });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/modals/datepicker-modal/datepicker-modal.component.ts